module.exports = __webpack_public_path__ + "static/placeholder-852ba4702200c14fa32b842c83d5b00e.png";